export default "__VITE_ASSET__CTx6Ih1V__";